import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { getMaintenanceLevelsDetails, saveMaintenanceLevels } from './actions/MaintenanceLevelsActions';
import { isValidNameWithSpace, renderCheckBox, renderTextField, renderAutoCompleteSingleSelect } from '../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../components/buttons';
import SmallLoader from '../../../img/small-loader.gif';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../../src/actions/utilAction';



class MaintenanceLevelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      maintenanceLevelId: props.maintenanceLevelId
    };
  }

  componentWillMount() {
    if (this.state.maintenanceLevelId) {
      this.props.getMaintenanceLevelsDetails(this.state.maintenanceLevelId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    let postData = {
      "id": this.props.maintenanceLevelId || 0,
      "name": formProps.name,
      "collectionFrequencyId": formProps.collectionFrequencyId,     
      "isActive":  formProps.isActive || false
    }
    this.props.clearFieldErrorArray();
    this.props.saveMaintenanceLevels(postData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.maintenanceLevelId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
    <SubmitButtonModalDisabled label="Loading" /> :
    <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
        submitButton,
      ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.maintenanceLevelId
            ? "Edit Maintenance Level"
            : "Add Maintenance Level"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="name"
                    type="text"          
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Maintenance Level Name')}
                    customError={displayCustomError('NAME', this.props.fieldError)}        
                    maxLength="250"
                    label="Maintenance Level Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField}
                  />
                </div>
                <div className="col-sm-12 require mt-20">
                  <Field
                    name="collectionFrequencyId"
                    label="Collection Frequency"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.collectionFrequency}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field
                    className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

MaintenanceLevelModal = reduxForm({
    form: 'MaintenanceLevelModalForm',
    validate,
    enableReinitialize: true,
})(MaintenanceLevelModal);


function mapStateToProps(state, ownProps) { 
  console.log('collectionFrequency master fata reducer------', state.maintenanceLevels.master_data)
  let initialValueData = {
    isActive: true,
  };

  if (ownProps.maintenanceLevelId && state.maintenanceLevels.maintenanceLevelsListDetails) {
    initialValueData = state.maintenanceLevels.maintenanceLevelsListDetails.data || null;
  } 

  return {
    loading: state.maintenanceLevels.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    collectionFrequency: state.maintenanceLevels.master_data ? state.maintenanceLevels.master_data.collectionFrequency : [],
    initialValues: initialValueData,
  }
}

export default connect(mapStateToProps,{getMaintenanceLevelsDetails, checkFieldExistence, clearFieldErrorArray, saveMaintenanceLevels})(MaintenanceLevelModal);



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/maintenanceLevel/maintenanceLevel_Modal.js